import { IClient, IUser } from "@/lib/interfaces";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthSliceState {
  accessToken: string;
  user: IUser;
  authState: "IDLE" | "LOADING";
  isSuperUser: boolean;
}

type AuthType = {
  accessToken: string;
  user: IUser;
  authState: "IDLE" | "LOADING";
  isSuperUser: boolean;
};

const initialState: AuthType = {
  accessToken: "",
  user: {},
  authState: "LOADING",
  isSuperUser: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAccessToken(
      state: AuthSliceState,
      action: PayloadAction<{ accessToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
    },
    setUser(
      state: AuthSliceState,
      action: PayloadAction<{ user: IUser; company: IClient | undefined }>
    ) {
      const { company, user } = action.payload;

      state.user = { ...user, company };

      if (user.superuser === "1") {
        state.isSuperUser = true;
      }
    },
    userLogout: () => initialState,
    setAuthState(
      state: AuthSliceState,
      action: PayloadAction<{ authState: "IDLE" | "LOADING" }>
    ) {
      state.authState = action.payload.authState;
    },
  },
});

export const { userLogout, setAccessToken, setUser, setAuthState } =
  userSlice.actions;

export default userSlice.reducer;
